import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MCQFeedbackDialog } from "./MCQFeedbackDialog";
import { useEntitlement } from "@/hooks/useEntitlement";
import { useAuth } from "@/hooks/useAuth";

interface MCQFeedbackButtonProps {
  mcqId: string;
  mcqStem: string;
}

export function MCQFeedbackButton({ mcqId, mcqStem }: MCQFeedbackButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { user } = useAuth();
  const { examSlug, loading } = useEntitlement();

  // Only show to authenticated users with active subscriptions
  if (!user || loading || !examSlug) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setDialogOpen(true)}
        className="gap-2"
      >
        <MessageSquarePlus className="h-4 w-4" />
        Suggest Improvement
      </Button>
      
      <MCQFeedbackDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        mcqId={mcqId}
        mcqStem={mcqStem}
      />
    </>
  );
}
